




























module.exports = {
  props: ['event', 'contact']

  data: ->
    current_user: Session.current_user
    email_value: Session.current_user.email

  methods:
    remove_opening_register_pixel: (text) ->
      result = text.replace(/<img[^>]*src="https:\/\/api.nylas.com[^>]*>/g, '')
      result = result.replace(/(<base \D*">)/g, '')
      result = result.replace(/<img[^>]*https\:\/\/nyl.as[^>]*>/g, '')
      result = result.replace(/<img[^>]*src="http:\/\/post.spmailtechn.com\/q[^>]*>/g, '')
      result = result.replace(/<img[^>]*src="https:\/\/t.nylas.com\/open[^>]*>/g, '')
      result

    resendEmail: ->
      new ContactEventsResource().resendEmail @resendEmailSuccess, @unknownError, { @event, email: @email_value }

    resendEmailSuccess: ->
      alertify.success("Email reenviado com sucesso!")
      @event.showEmail = false

    iconClass: ->
      switch @event.type()
        when 'ContactCreatedEvent' then 'plus-icon'

        when 'CreateContactEvent'
          switch @event.description
            when 'reev' then 'plus-icon'
            when 'pipedrive' then 'pipedrive-icon'
            when 'rdstation' then 'rdstation-icon'
            when 'sharpspring' then 'sharpspring-icon'
            when 'leadlovers' then 'leadlovers-icon'
            when 'hubspot' then 'hs-icon'
            else 'plus-icon'

        when 'UpdateContactEvent'
          switch @event.description
            when 'reev' then 'plus-icon'
            when 'pipedrive' then 'pipedrive-icon'
            when 'rdstation' then 'rdstation-icon'
            when 'sharpspring' then 'sharpspring-icon'
            when 'leadlovers' then 'leadlovers-icon'
            when 'hubspot' then 'hs-icon'
            else 'plus-icon'

        when 'ContactCretedByAutomationEvent'
          switch @event.metadata.crm
            when 'rd_station' then 'rdstation-icon'
            when 'hubspot' then 'hs-icon'
            else 'plus-icon'

        when 'ContactInsertedFlowByAutomationEvent' then 'added-to-flow-icon'
        when 'ContactAddedToFlowEvent' then 'added-to-flow-icon'
        when 'CallEvent' then 'task-icon phonecall-task-icon'

        when 'EmailEvent'
          @event.emailIconClasses()

        when 'RecipientStatusChangedEvent'
          "status-icon contact-event-subicon #{@statusSubiconClass(@event.detail())}"

        when 'ContactStageChangedEvent'
          icon = if @event.detail() == 'lost' then 'stage-lost-icon' else 'stage-default-icon'
          "stage-icon #{icon}"

        when 'ContactRemovedFromFlowEvent' then "removed-from-flow-icon"

    statusSubiconClass: (detail) ->
      "#{detail}-icon"

    canResendEmail: ->
      return false if @current_user.email_service_requires_authorization
      @current_user.isAdmin() || (@current_user.id == @contact.user_id)

    canViewEmail: ->
      @current_user.isAdmin() || @current_user.isManager() || (@current_user.id == @contact.user_id)

}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/event.vue